<template>
  <div class="widget">
    <div class="title">{{ $t('pages_home_fund_001') }}</div>
    <div class="fund-op-row">
      <div class="estimate">
        <a-spin v-if="amountLoading" />
        <div v-else class="title-sub">{{ $t('pages_home_fund_002') + totalAmount + ' USD' }}</div>
      </div>
      <div class="short-cut">
        <a-button type="primary" @click="handleOutbound">{{ $t('pages_home_fund_003') }}</a-button>
        <a-button type="primary" @click="handleInbound">{{ $t('pages_home_fund_004') }}</a-button>
        <a-button type="primary" @click="handleExchange">{{ $t('pages_home_fund_005') }}</a-button>
      </div>
    </div>
    <div class="currency-cards">
      <div v-for="(cur, index) in filteredCurList" :key="index" class="card">
        <!-- only show totalAmount or freezeAmount > 0  card -->
        <div class="cur-title">
          <img :src="getCountryLogo(cur.curType)">
          <span>{{ cur.curType }}</span>
        </div>
        <div class="balance">
          <div>{{ $t('pages_home_fund_006') }} </div>
          <div>{{ cur.totalAmount ? parseMoney(cur.totalAmount, cur.curType) : '0.00' }}</div>
        </div>
        <div class="balance">
          <div>{{ $t('pages_home_fund_007') }}:</div>
          <div v-if="cur.freezeAmount > 0" class="confirm">{{ parseMoney(cur.freezeAmount, cur.curType) }}</div>
          <div v-else>0.00</div>
        </div>
      </div>
      <!-- <div class="card-add" @click="handleReceiveAdd">
        <div class="add">+</div>
        <div>{{ $t('pages_home_fund_008') }}</div>
      </div> -->
    </div>
  </div>
</template>

<script>
import { reactive, toRefs, onUnmounted, defineComponent, computed } from 'vue'
import { _home } from '@/api'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { getCountryLogo, parseMoney } from '@/util'
export default defineComponent({
  name: 'Fund',
  setup() {
    let timer = null
    const router = useRouter()
    const store = useStore()
    const state = reactive({
      amountLoading: false,
      totalAmount: 0
    })

    onUnmounted(() => {
      clearInterval(timer)
    })

    const init = async () => {
      store.dispatch('getCurList')
    }

    const loadWalletRatio = async () => {
      state.amountLoading = true
      clearInterval(timer)
      const res = await _home.getWalletRatio()
      if (res.data.succ) {
        state.totalAmount = parseMoney(res.data.data)
        state.amountLoading = false
      } else {
        timer = setInterval(() => {
          loadWalletRatio()
        }, 30000)
      }
    }

    init()
    loadWalletRatio()

    const filteredCurList = computed(() => {
      console.log('store.getters.curList', store.getters.curList)
      // sort by totalAmount + freezeAmount
      const list = [...store.getters.curList].sort((a, b) => b.totalAmount + b.freezeAmount - a.totalAmount - a.freezeAmount)
      if (list.length > 4) {
        if (list[4].totalAmount + list[4].freezeAmount === 0) {
          return list.slice(0, 4)
        }
      }

      return list
    })

    const handleOutbound = () => {
      router.push('/funds/outbounds')
    }

    const handleInbound = () => {
      router.push('/funds/inbounds')
    }

    const handleExchange = () => {
      router.push('/exchange/apply')
    }

    const handleReceiveAdd = () => {
      router.push('/receive/apply_type')
    }

    return {
      filteredCurList,
      getCountryLogo,
      parseMoney,
      handleOutbound,
      handleInbound,
      handleExchange,
      handleReceiveAdd,
      ...toRefs(state)
    }
  }
})
</script>

<style lang="less" scoped>
.fund-op-row {
  display: flex;
  flex-direction: row;
  padding-top: 20px;
  align-items: center;
  width: 100%;
  .ant-spin {
    margin-left: 20px;
    // 垂直居中
    display: flex;
    align-items: center;
  }
  .estimate {
    font-size: 14px;
    width: 300px;
    color: #999;
  }
  .short-cut {
    display: flex;
    flex-direction: row;
    margin-left: 50px;
    .ant-btn {
      // roumd rect
      border-radius: 3px;
      margin-left: 20px;
      font-weight: bold;
      // button size
      height: 40px;
    }

  }
}
.currency-cards {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  padding-top: 20px;
  flex-wrap: wrap;
  .card-add {
    width: 180px;
    height: 150px;
    background: rgb(240, 245, 255);
    border-radius: 5px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: 10px;
    font-size: 16px;
    color: @main-color;
    cursor: pointer;
    &:hover {
      background: #e6f7ff;
    }
    .add {
      font-size: 40px;
    }
  }
  .card {
    width: 165px;
    height: 150px;
    background: rgb(240, 245, 255);
    border-radius: 5px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin: 10px;
    .cur-title {
      display: flex;
      flex-direction: row;
      font-size: 16px;
      font-weight: 500;
      padding: 10px;
      padding-top: 30px;
      padding-bottom: 50px;
      align-items: center;
      height: 40px;
      img {
        width: 40px;
        height: 25px;
        margin-right: 10px;
        // round rect
        border-radius: 3px;
      }
    }
    .content {
      padding: 10px;
    }
    .balance {
      display: flex;
      flex-direction: row;
      width: 100%;
      justify-content: space-between;
      font-size: 14px;
      padding-left: 10px;
      padding-right: 10px;
      .confirm {
        color: @main-color;
      }
    }

  }
}
</style>
